// Lessons staff have added but not published yet. A learner sees them as
// "coming soon" — on the course page, in each module and on the course cards —
// never as a lock, because there is nothing the learner could do to open them.

import { defineMessages, plural } from './index'

export default defineMessages(
  {
    soon: 'Tez orada',
    courseSoonTitle: 'Bu kurs darslari tez orada ochiladi',
    courseSoonCount: 'Hozir {n} ta dars tayyorlanmoqda — chop etilishi bilan shu yerda paydo bo‘ladi.',
    courseSoonEmpty: 'Darslar chop etilishi bilan shu yerda paydo bo‘ladi.',
    moreSoon: 'Yana {n} ta dars tez orada qo‘shiladi.',
    moduleSoon: 'Bu bo‘lim darslari tez orada ochiladi',
    cardSoon: 'Darslar tez orada ochiladi',
    cardMoreSoon: '+{n} ta dars tez orada',
  },
  {
    en: {
      soon: 'Coming soon',
      courseSoonTitle: 'The lessons of this course are coming soon',
      courseSoonCount: (v, lang) =>
        plural(lang, Number(v.n), {
          one: '{n} lesson is being prepared right now. It will appear here as soon as it is published.',
          other: '{n} lessons are being prepared right now. They will appear here as soon as they are published.',
        }),
      courseSoonEmpty: 'Lessons will appear here as soon as they are published.',
      moreSoon: (v, lang) =>
        plural(lang, Number(v.n), {
          one: '{n} more lesson is coming soon.',
          other: '{n} more lessons are coming soon.',
        }),
      moduleSoon: 'The lessons of this module are coming soon',
      cardSoon: 'Lessons open soon',
      cardMoreSoon: (v, lang) =>
        plural(lang, Number(v.n), {
          one: '+{n} lesson coming soon',
          other: '+{n} lessons coming soon',
        }),
    },
    ru: {
      soon: 'Скоро',
      courseSoonTitle: 'Уроки этого курса скоро откроются',
      // The 'one' form also serves 21, 31, 101…: «он… его» is right only for
      // a single lesson, and twenty-one of them are «они… их».
      courseSoonCount: (v, lang) =>
        plural(lang, Number(v.n), {
          one:
            Number(v.n) === 1
              ? 'Сейчас готовится {n} урок — он появится здесь, как только его опубликуют.'
              : 'Сейчас готовится {n} урок — они появятся здесь, как только их опубликуют.',
          few: 'Сейчас готовятся {n} урока — они появятся здесь, как только их опубликуют.',
          many: 'Сейчас готовятся {n} уроков — они появятся здесь, как только их опубликуют.',
          other: 'Сейчас готовятся {n} урока — они появятся здесь, как только их опубликуют.',
        }),
      courseSoonEmpty: 'Уроки появятся здесь, как только их опубликуют.',
      moreSoon: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Скоро откроется ещё {n} урок.',
          few: 'Скоро откроются ещё {n} урока.',
          many: 'Скоро откроются ещё {n} уроков.',
          other: 'Скоро откроются ещё {n} урока.',
        }),
      moduleSoon: 'Уроки этого модуля скоро откроются',
      cardSoon: 'Уроки скоро откроются',
      cardMoreSoon: (v, lang) =>
        plural(lang, Number(v.n), {
          one: '+{n} урок скоро',
          few: '+{n} урока скоро',
          many: '+{n} уроков скоро',
          other: '+{n} урока скоро',
        }),
    },
    de: {
      soon: 'Demnächst',
      courseSoonTitle: 'Die Lektionen dieses Kurses folgen in Kürze',
      courseSoonCount: (v, lang) =>
        plural(lang, Number(v.n), {
          one: 'Gerade wird {n} Lektion vorbereitet. Sie erscheint hier, sobald sie veröffentlicht ist.',
          other: 'Gerade werden {n} Lektionen vorbereitet. Sie erscheinen hier, sobald sie veröffentlicht sind.',
        }),
      courseSoonEmpty: 'Die Lektionen erscheinen hier, sobald sie veröffentlicht sind.',
      moreSoon: (v, lang) =>
        plural(lang, Number(v.n), {
          one: '{n} weitere Lektion folgt in Kürze.',
          other: '{n} weitere Lektionen folgen in Kürze.',
        }),
      moduleSoon: 'Die Lektionen dieses Moduls folgen in Kürze',
      cardSoon: 'Lektionen folgen in Kürze',
      cardMoreSoon: (v, lang) =>
        plural(lang, Number(v.n), {
          one: '+{n} Lektion folgt bald',
          other: '+{n} Lektionen folgen bald',
        }),
    },
  },
)
